import React from 'react';

const XGroupList = ({ groups, loading, onEdit, onDelete, onClone }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-2 text-muted">Loading groups...</p>
      </div>
    );
  }

  if (groups.length === 0) {
    return (
      <div className="card">
        <div className="card-body text-center py-5">
          <i className="bi bi-people display-1 text-muted mb-3"></i>
          <h5 className="text-muted">No Groups Found</h5>
          <p className="text-muted">Create your first group to organize X users</p>
        </div>
      </div>
    );
  }

  return (
    <div className="row">
      {groups.map((group) => (
        <div key={group.id} className="col-md-6 col-lg-4 mb-4">
          <div className="card h-100">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-start mb-2">
                <h5 className="card-title mb-0">
                  <i className="bi bi-people me-2 text-primary"></i>
                  {group.name}
                </h5>
              </div>

              <div className="mb-3">
                <div className="d-flex align-items-center text-muted small mb-1">
                  <i className="bi bi-person-badge me-2"></i>
                  <span>{group.x_user_ids?.length || 0} user(s)</span>
                </div>
                <div className="d-flex align-items-center text-muted small">
                  <i className="bi bi-clock me-2"></i>
                  <span>Created: {formatDate(group.created_at)}</span>
                </div>
              </div>

              {group.x_user_ids && group.x_user_ids.length > 0 && (
                <div className="mb-3">
                  <small className="text-muted">Users:</small>
                  <div className="mt-1" style={{ maxHeight: '100px', overflowY: 'auto' }}>
                    {group.x_user_ids.slice(0, 5).map((userId, index) => (
                      <span
                        key={index}
                        className="badge bg-light text-dark me-1 mb-1 font-monospace"
                        style={{ fontSize: '0.75rem' }}
                      >
                        {userId}
                      </span>
                    ))}
                    {group.x_user_ids.length > 5 && (
                      <span className="badge bg-secondary mb-1">
                        +{group.x_user_ids.length - 5} more
                      </span>
                    )}
                  </div>
                </div>
              )}

              <div className="d-flex gap-2 mt-3">
                <button
                  className="btn btn-sm btn-outline-primary flex-fill"
                  onClick={() => onEdit(group)}
                  title="Edit group"
                >
                  <i className="bi bi-pencil me-1"></i>
                  Edit
                </button>
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => onClone(group)}
                  title="Clone group"
                >
                  <i className="bi bi-files"></i>
                </button>
                <button
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => onDelete(group.id)}
                  title="Delete group"
                >
                  <i className="bi bi-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default XGroupList;
